import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import SEOPage from './pages/SEOPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettings from './pages/AdminSettings';
import PropertyForm from './pages/PropertyForm';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Main pages */}
            <Route path="/" element={<Home />} />
            
            {/* SEO Pages - Indexable by Google */}
            <Route path="/immobilier-netanya" element={<SEOPage />} />
            <Route path="/ir-yamim" element={<SEOPage />} />
            <Route path="/nat-600" element={<SEOPage />} />
            <Route path="/appartement-vue-mer-netanya" element={<SEOPage />} />
            <Route path="/projets-neufs-netanya" element={<SEOPage />} />
            <Route path="/vente-appartement-netanya" element={<SEOPage />} />
            <Route path="/location-appartement-netanya" element={<SEOPage />} />
            
            {/* Admin pages */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/property/new" element={<PropertyForm />} />
            <Route path="/admin/property/:id" element={<PropertyForm />} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
